import React, { useContext } from 'react';
import { getImageUrl } from '@culture/common-helpers/cultureUtils';

import { ImageFormatContext } from 'contexts/ImageFormatContext';
import { useLightbox } from 'hooks/useLightbox';
import LazyLoadImage from 'components/LazyLoad/Image';

import { MaterialPropType } from 'propTypes/common';

import styles from './styles.module.scss';

const StyledContentGallery = ({ material }) => {
	const { files } = material;
	const imageFormat = useContext(ImageFormatContext);
	const [lightbox, showLightbox] = useLightbox(files);
	const isSingleFile = files.length === 1;

	const renderImage = (imageSrc, title) => (
		<img
			className={styles.StyledContentGallery_Image}
			src={imageSrc}
			alt={title || ''}
			aria-hidden
		/>
	);

	const renderImageGallery = (file, index) => {
		const {
			_id,
			meta: { title },
			width,
			height
		} = file;
		const previewImageSrc = getImageUrl(file, {
			format: imageFormat,
			params: {
				crop: 'fill',
				gravity: 'center',
				width: 1020
			}
		});
		const lowQualityImageSrc = getImageUrl(file, {
			params: { transform: 'average' }
		});
		const aspectRatio = width / height;
		const itemStyle = !isSingleFile ? { flex: aspectRatio } : null;

		return (
			// eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
			<div
				key={_id}
				className={styles.StyledContentGallery_Item}
				style={itemStyle}
				onClick={() => showLightbox(index)}
			>
				<LazyLoadImage
					className={styles.StyledContentGallery_WrapImage}
					imageSrc={previewImageSrc}
					placeholder={renderImage(lowQualityImageSrc, title)}
					preloadImage
				>
					{renderImage(previewImageSrc, title)}
				</LazyLoadImage>
			</div>
		);
	};

	return files?.length ? (
		<>
			<div className={styles.StyledContentGallery}>
				{files.map((file, index) => renderImageGallery(file, index))}
			</div>
			{lightbox}
		</>
	) : null;
};

StyledContentGallery.propTypes = {
	material: MaterialPropType
};

export default StyledContentGallery;
